import React from 'react'

import { useIncidentIds } from '../hooks'

import IncidentListItem from './IncidentListItem'

import styles from './IncidentList.module.css'

const IncidentList = () => {
  const ids = useIncidentIds()

  return (
    <>
      <ul className={styles.list}>
        {ids.map((id, i) => (
          <IncidentListItem incidentId={id} key={i} />
        ))}
      </ul>
    </>
  )
}

export default IncidentList
